import { render } from "./QueueManagement.vue?vue&type=template&id=25630c1e&scoped=true"
import script from "./QueueManagement.vue?vue&type=script&lang=js"
export * from "./QueueManagement.vue?vue&type=script&lang=js"

import "./QueueManagement.vue?vue&type=style&index=0&id=25630c1e&lang=css"
import "./QueueManagement.vue?vue&type=style&index=1&id=25630c1e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25630c1e"]])

export default __exports__